module.exports = __webpack_public_path__ + "img/8.6277f378.jpg";